import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef,
   ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-s-pdf-viewer',
  templateUrl: './s-pdf-viewer.component.html',
  styleUrls: ['./s-pdf-viewer.component.less']
})
export class SPdfViewerComponent implements OnInit {
  @Input() title = '预览';
  @Input() src: any; // 'https://cors-anywhere.herokuapp.com/https://www.copyright.gov/legislation/dmca.pdf'
  @Input() viewWidth: any = 1300;
  @Input() viewHeight: any = 700;
  @Output() out: EventEmitter<any> = new EventEmitter();
  constructor(
    private domSanitizer: DomSanitizer,
    private ref: ChangeDetectorRef
  ) { }
  isVisible = false;
  pdfSrc: any = 'ssss';
  html: any;

  ngOnInit(): void {
    this.isVisible = true;

    // this.viewWidth = this.viewWidth;
    this.html = this.domSanitizer.bypassSecurityTrustHtml(`
    <iframe src="../../../../assets/pdfjs-2.0.943-dist/web/viewer.html?file=
    ${'https://cors-anywhere.herokuapp.com/'}${this.src}" width="${this.viewWidth}" height="${this.viewHeight}" class="iframe"></iframe>`);
  }
  handleCancel() {
    this.isVisible = false;
  }

}
